import { CustomersNav } from './customers-nav.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { SearchBarModule } from '../search-bar/search-bar.module'
import { FuzzySearchModule } from 'src/pipes/fuzzy-search/fuzzy-search.module'
import { ClientSetupNavComponentModule } from './client-setup-nav/client-setup-nav.module'
import { TooltipModule } from 'ngx-bootstrap/tooltip'
import { TooltipCopyPipe } from './pipes/tooltip-copy.pipe'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SearchBarModule,
    FuzzySearchModule,
    ClientSetupNavComponentModule,
    TooltipModule
  ],
  declarations: [
    CustomersNav,
    TooltipCopyPipe,
  ],
  exports: [
    CustomersNav
  ]
})
export class CustomersNavComponentModule {}
